export default "__VITE_ASSET__rx7gpeP6__"